<template>
  <NuxtLayout>
    <div class="app_container">
      <div class="course_content">
        <!-- 已选分类：结果页 -->
        <template v-if="map.categoryId && href != 'yhx.ykumda.com'">
          <div class="result_breadcrumb_bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/course/list' }">{{ courseCenterNavName }}</el-breadcrumb-item>
              <el-breadcrumb-item
                v-for="(item, index) in categoryPath"
                :key="item.id"
                :to="index < categoryPath.length - 1 ? { path: '/course/list', query: getBreadcrumbQuery(item.id) } : undefined"
              >
                {{ item.categoryName }}
              </el-breadcrumb-item>
            </el-breadcrumb>
            <NuxtLink to="/account/course" class="my_course_link">我的课程</NuxtLink>
          </div>

          <div class="result_filter_header">
            <div class="filter_row">
              <span class="filter_label">课程大类：</span>
              <div class="filter_tags">
                <span
                  v-for="item in opts.rawCategoryList"
                  :key="item.id"
                  class="filter_tag"
                  :class="{ active: isPathLevelActive(0, item.id) }"
                  @click="handleSelectCategory(item)"
                >{{ item.categoryName }}</span>
              </div>
            </div>
            <div v-if="filterSecondLevel.length" class="filter_row">
              <span class="filter_label">课程分类：</span>
              <div class="filter_tags">
                <span
                  v-for="item in filterSecondLevel"
                  :key="item.id"
                  class="filter_tag"
                  :class="{ active: isPathLevelActive(1, item.id) }"
                  @click="handleSelectCategory(item)"
                >{{ item.categoryName }}</span>
              </div>
            </div>
            <div v-if="filterThirdLevel.length" class="filter_row">
              <span class="filter_label">课程科目：</span>
              <div class="filter_tags">
                <span
                  v-for="item in filterThirdLevel"
                  :key="item.id"
                  class="filter_tag"
                  :class="{ active: String(map.categoryId) === String(item.id) }"
                  @click="handleSelectCategory(item)"
                >{{ item.categoryName }}</span>
              </div>
            </div>
          </div>

          <div v-loading="ctrl.tableLoading" class="ov_course_content courseStep1">
            <index-course
              :visible="opts.tableList.length > 0"
              :component-info="{ config: { showType: 1 }, data: opts.tableList }"
            />
          </div>
        </template>

        <!-- 未选分类：分类浏览面板 -->
        <template v-else>
          <div ref="header" class="course_header_content mgt20" v-if="href != 'yhx.ykumda.com'">
            <div class="course_row courseStep2" v-if="opts.navTypeList?.length > 0">
              <span class="left_title mgr10">资源类型：</span>
              <div class="search_type_list bg_box">
                <span
                  v-for="item in opts.navTypeList"
                  :key="item.navCode"
                  class="search_type_item"
                  :class="{ active: map.courseType === item.navCode }"
                  @click="handleChangeType(item.navCode)"
                >{{ item.navName }}</span>
              </div>
            </div>
            <div v-if="ctrl.showCate && opts.rawCategoryList.length" class="category_filter_panel courseStep3">
              <div class="category_sidebar">
                <div
                  v-for="item in opts.rawCategoryList"
                  :key="item.id"
                  class="sidebar_item"
                  :class="{ active: String(opts.activeFirstCategoryId) === String(item.id) }"
                  @mouseenter="handleHoverFirstCategory(item)"
                  @click="handleClickFirstCategory(item)"
                >
                  <i class="sidebar_dot" />
                  <span class="sidebar_name">{{ item.categoryName }}</span>
                </div>
              </div>
              <div
                class="category_content_panel"
                @mouseleave="restoreDefaultSecondHover"
              >
                <template v-if="activeFirstCategoryChildren.length">
                  <div
                    v-for="second in activeFirstCategoryChildren"
                    :key="second.id"
                    class="category_row"
                    :class="{
                      'is-leaf': !second.childrenList?.length,
                      'is-hover': String(hoverSecondCategoryId) === String(second.id),
                    }"
                    @mouseenter="hoverSecondCategoryId = second.id"
                  >
                    <div
                      class="row_label"
                      @click="handleSelectCategory(second)"
                    >
                      {{ second.categoryName }}
                    </div>
                    <div v-if="second.childrenList?.length" class="row_tags">
                      <span
                        v-for="(third, idx) in second.childrenList"
                        :key="third.id"
                        class="tag_item"
                      >
                        <span
                          class="tag_link"
                          :class="{ active: isCategoryActive(third.id) }"
                          @click="handleSelectCategory(third)"
                        >{{ third.categoryName }}</span>
                        <span
                          v-if="idx < second.childrenList.length - 1"
                          class="tag_divider"
                        >|</span>
                      </span>
                    </div>
                  </div>
                </template>
                <div
                  v-else-if="activeFirstCategory"
                  class="category_empty_panel"
                  @click="handleSelectCategory(activeFirstCategory)"
                >
                  <div class="empty_title">「{{ activeFirstCategory.categoryName }}」暂无下级分类</div>
                  <div class="empty_desc">点击此处或左侧分类即可查看该大类下的课程</div>
                </div>
              </div>
            </div>
          </div>
          <div class="fliter_row" v-if="href != 'yhx.ykumda.com'">
            <div class="left_wrapper">
              <span
                v-for="(item, index) in opts.orderByTypeEnum"
                :key="index"
                class="search_item"
                :class="{
                  active: map.orderByType === item.code,
                  not_right: index === opts.orderByTypeEnum.length,
                }"
                @click="handleChangeOrderBy(item.code)"
              >{{ item.desc }}</span>
            </div>
          </div>
          <div v-loading="ctrl.tableLoading" class="ov_course_content courseStep1">
            <index-course
              :visible="opts.tableList.length > 0"
              :component-info="{ config: { showType: 1 }, data: opts.tableList }"
            />
          </div>
        </template>

        <div v-show="page.totalPage > 1" ref="content" class="page_list">
          <el-pagination
            v-model:currentPage="page.pageCurrent"
            background
            layout="prev, pager, next,jumper"
            :total="page.totalCount"
            :page-size="page.pageSize"
            @current-change="getTableList"
          />
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { useUserStore } from "../../stores/user";
import { useNavStore } from "@/stores/nav";
import { getAuthCourseList, getCourseList, getNavTypeList } from "../../api/course";
import { categoryLists } from "../../api/system";
import { getHearder } from "@/api/layouts";
import { handleNavigate } from "@/utils/utils";
import { computed, nextTick, onMounted, watch } from "vue";
import { getStore, setStore } from "@/utils/storage";
import cookie from "@/utils/cookies";

const route = useRoute();
const router = useRouter();
const cookieData = cookie.getShop();
const navStore = useNavStore();
const { data: headerNavData } = useNuxtData("headers");

/** 从网站导航配置解析「课程中心」菜单名（与顶栏一致） */
const resolveCourseCenterNavName = (contentList) => {
  if (!Array.isArray(contentList) || !contentList.length) return "";
  // 功能页：targetType=1（功能）+ targetAddr=2（课程列表）
  const byFunction = contentList.find(
    (item) =>
      item.status !== false &&
      item.status !== 0 &&
      Number(item.targetType) === 1 &&
      Number(item.targetAddr) === 2
  );
  if (byFunction?.navName) return byFunction.navName;

  const matched = contentList.find((item) => {
    if (item.status === false || item.status === 0) return false;
    const path = (item.path || handleNavigate(item) || "").split("?")[0];
    return path === "/course/list";
  });
  return matched?.navName || "";
};

const courseCenterNavName = computed(() => {
  const fromStore = resolveCourseCenterNavName(navStore.nav?.contentList);
  if (fromStore) return fromStore;
  const fromHeader = resolveCourseCenterNavName(headerNavData.value?.contentList);
  return fromHeader || "学习中心";
});

const ensureCourseCenterNavName = async () => {
  if (resolveCourseCenterNavName(navStore.nav?.contentList)) return;
  if (resolveCourseCenterNavName(headerNavData.value?.contentList)) return;
  try {
    const data = await getHearder();
    if (data?.contentList?.length) {
      data.contentList.forEach((navItem) => {
        navItem.path = handleNavigate(navItem);
      });
      navStore.setNav(data);
    }
  } catch (e) {
    console.error(e);
  }
};

useHead({
  title: computed(() => `资源中心-${cookieData.shopName}`),
  meta: [
    {
      hid: "keywords",
      name: "keywords",
      content: "资源中心",
    },
    {
      hid: "description",
      name: "description",
      content: "资源中心",
    },
  ],
});
const store = useUserStore();
const { getToken, getEnumList, userView } = store;
const header = ref(null);
const content = ref(null);
const href = ref(null)
const map = reactive({
  courseType: "",
  categoryId: "",
  chargeType: "",
  orderByType: 1,
  isCourseQuestion: 1,
});
const token = computed(() => {
  return getToken();
});
const userInfo = computed(() => {
  return userView;
});
const opts = reactive({
  errorNum: 0,
  lastCategory: [],
  tableList: [],
  categoryList: [],
  rawCategoryList: [],
  activeFirstCategoryId: "",
  chargeTypeEnum: [],
  PeriodTypeEnum: [],
  navTypeList: [],
  orderByTypeEnum: [],
  categoryChild: {},
  infoTimer: null,
  style: {
    height: "525px",
  },
  isFree: false,
});
const ctrl = reactive({
  tableLoading: false,
  showCate: true,
});
const page = reactive({
  pageCurrent: 1,
  pageSize: 25,
  totalCount: 0,
  totalPage: 1,
});

const findCategoryPath = (list, targetId, path = []) => {
  if (!list?.length || !targetId) return null;
  for (const item of list) {
    const currentPath = [...path, item];
    if (String(item.id) === String(targetId)) return currentPath;
    if (item.childrenList?.length) {
      const found = findCategoryPath(item.childrenList, targetId, currentPath);
      if (found) return found;
    }
  }
  return null;
};

const categoryPath = computed(() => {
  if (!map.categoryId || !opts.rawCategoryList.length) return [];
  return findCategoryPath(opts.rawCategoryList, map.categoryId) || [];
});

const filterSecondLevel = computed(() => categoryPath.value[0]?.childrenList || []);
const filterThirdLevel = computed(() => categoryPath.value[1]?.childrenList || []);

const isPathLevelActive = (level, id) => {
  if (!categoryPath.value.length) return false;
  const pathItem = categoryPath.value[level];
  if (pathItem && String(pathItem.id) === String(id)) return true;
  if (level === 1 && categoryPath.value.length === 2 && !filterThirdLevel.value.length) {
    return String(categoryPath.value[1].id) === String(id);
  }
  return false;
};

const getBreadcrumbQuery = (categoryId) => {
  const query = { ...(route.query || {}) };
  if (categoryId) {
    query.categoryId = categoryId;
  } else {
    delete query.categoryId;
  }
  return query;
};

const findFirstCategoryById = (list, targetId) => {
  if (!list?.length || !targetId) return null;
  for (const first of list) {
    if (String(first.id) === String(targetId)) return first;
    const found = findInCategoryTree(first.childrenList, targetId);
    if (found) return first;
  }
  return null;
};

const findInCategoryTree = (list, targetId) => {
  if (!list?.length || !targetId) return null;
  for (const item of list) {
    if (String(item.id) === String(targetId)) return item;
    const found = findInCategoryTree(item.childrenList, targetId);
    if (found) return found;
  }
  return null;
};

const hasCategoryChildren = (item) =>
  Array.isArray(item?.childrenList) && item.childrenList.length > 0;

/** 浏览面板下，叶子一级分类悬停预览用的分类 ID */
const browsePreviewCategoryId = ref("");
/** 二级目录悬停高亮（圆点跟随） */
const hoverSecondCategoryId = ref("");

const activeFirstCategory = computed(() => {
  return (
    opts.rawCategoryList.find(
      (item) => String(item.id) === String(opts.activeFirstCategoryId)
    ) || null
  );
});

const activeFirstCategoryChildren = computed(() => {
  return activeFirstCategory.value?.childrenList || [];
});

const isCategoryActive = (id) => {
  if (map.categoryId) {
    return String(map.categoryId) === String(id);
  }
  return String(browsePreviewCategoryId.value) === String(id);
};

const getListCategoryId = () => {
  // 已选分类结果页用 map.categoryId；浏览面板用预览 ID（一级无下级或默认第一个二级）
  if (map.categoryId) return map.categoryId;
  return browsePreviewCategoryId.value || "";
};

/** 一级分类选中后：无下级则预览自身，有下级则默认选中第一个二级 */
const resolveFirstCategoryPreviewId = (item) => {
  if (!item?.id) return "";
  if (!hasCategoryChildren(item)) return item.id;
  return item.childrenList[0]?.id || "";
};

/** 默认高亮当前一级下的第一个二级 */
const syncDefaultSecondHover = (firstItem) => {
  const target = firstItem || activeFirstCategory.value;
  if (!target || !hasCategoryChildren(target)) {
    hoverSecondCategoryId.value = "";
    return;
  }
  hoverSecondCategoryId.value = target.childrenList[0]?.id || "";
};

const restoreDefaultSecondHover = () => {
  syncDefaultSecondHover(activeFirstCategory.value);
};

const initCategoryState = (categoryTree) => {
  opts.rawCategoryList = categoryTree || [];
  if (!opts.rawCategoryList.length) {
    opts.activeFirstCategoryId = "";
    browsePreviewCategoryId.value = "";
    hoverSecondCategoryId.value = "";
    return;
  }
  if (route.query.categoryId) {
    const firstCategory = findFirstCategoryById(
      opts.rawCategoryList,
      route.query.categoryId
    );
    opts.activeFirstCategoryId =
      firstCategory?.id || opts.rawCategoryList[0].id;
    browsePreviewCategoryId.value = "";
    syncDefaultSecondHover(firstCategory || opts.rawCategoryList[0]);
  } else {
    opts.activeFirstCategoryId = opts.rawCategoryList[0].id;
    browsePreviewCategoryId.value = resolveFirstCategoryPreviewId(
      opts.rawCategoryList[0]
    );
    syncDefaultSecondHover(opts.rawCategoryList[0]);
  }
};
const leavingList = ref(false);
onBeforeRouteLeave(() => {
  leavingList.value = true;
});
const getTableList = () => {
  // 已点进详情时不要再把仍挂着的列表滚到顶部（否则会闪目录）
  if (leavingList.value || route.path !== "/course/list") return;
  document.querySelector("#app") && (document.querySelector("#app").scrollTop = 0);
  ctrl.tableLoading = true;
  if (route.query.courseType) {
    map.courseType = Number(route.query.courseType);
  } else {
    map.courseType = null;
  }
  
  // 确保 pageCurrent 有值，如果没有则设置为 1
  if (!page.pageCurrent || page.pageCurrent < 1) {
    page.pageCurrent = 1;
  }

  const listParams = {
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    ...map,
    categoryId: getListCategoryId() || null,
  };
  
  console.log('map', page.pageCurrent, page.pageSize);
  if (token.value) {
    getAuthCourseList(listParams)
      .then((res) => {
        ctrl.tableLoading = false;
        opts.tableList = res.list || [];
        page.pageCurrent = res.pageCurrent;
        page.totalCount = res.totalCount;
        page.totalPage = res.totalPage;
        if (opts.infoTimer) {
          clearInterval(opts.infoTimer);
          opts.infoTimer = null;
        }
      })
      .catch(() => {
        ctrl.tableLoading = false;
        opts.errorNum++;
        if (!opts.infoTimer) {
          opts.infoTimer = setInterval(getTableList, 3000);
        }
        if (opts.errorNum > 5) {
          if (opts.infoTimer) {
            clearInterval(opts.infoTimer);
            opts.infoTimer = null;
          }
        }
      });
  } else {
    getCourseList(listParams)
      .then((res) => {
        ctrl.tableLoading = false;
        opts.tableList = res.list || [];
        page.pageCurrent = res.pageCurrent;
        page.totalCount = res.totalCount;
        page.totalPage = res.totalPage;
        if (opts.infoTimer) {
          clearInterval(opts.infoTimer);
          opts.infoTimer = null;
        }
      })
      .catch(() => {
        ctrl.tableLoading = false;
      });
  }
};
const handleChangeType = (val) => {
  // 资源分类
  map.courseType = val;
  const query = route.query || {};
  router.replace({
    query: Object.assign({ ...query }, { courseType: val }, () => {}),
  });
};
const getData = (query) => {
  if (query.courseType) {
    map.courseType = Number(query.courseType);
  }
  if (query.orderByType) {
    map.orderByType = Number(query.orderByType);
  }

  if (query.categoryId) {
    map.categoryId = query.categoryId;
    browsePreviewCategoryId.value = "";
    const firstCategory = findFirstCategoryById(
      opts.rawCategoryList,
      query.categoryId
    );
    if (firstCategory) {
      opts.activeFirstCategoryId = firstCategory.id;
      syncDefaultSecondHover(firstCategory);
    }
  } else {
    map.categoryId = "";
    const activeFirst =
      opts.rawCategoryList.find(
        (item) => String(item.id) === String(opts.activeFirstCategoryId)
      ) || opts.rawCategoryList[0];
    if (activeFirst) {
      opts.activeFirstCategoryId = activeFirst.id;
      browsePreviewCategoryId.value = resolveFirstCategoryPreviewId(activeFirst);
      syncDefaultSecondHover(activeFirst);
    }
  }

  if (query.chargeType) {
    map.chargeType = Number(query.chargeType);
  }

  // 确保 pageCurrent 被正确设置后再调用 getTableList
  page.pageCurrent = 1;
  // 使用 nextTick 确保响应式数据更新后再调用
  nextTick(() => {
    getTableList();
  });
};
const handleChangeCharge = (val) => {
  // 收费状态
  map.chargeType = val;
  const query = route.query || {};
  router.replace({
    query: Object.assign({ ...query }, { chargeType: val }, () => {}),
  });
};
const handleChangeOrderBy = (val) => {
  // 排序
  map.orderByType = val;
  const query = route.query || {};
  router.replace({
    query: Object.assign({ ...query }, { orderByType: val }, () => {}),
  });
};

const getCategoryObj = (list, id) => {
  // 获取分类对象
  let obj = null;
  list.forEach((el) => {
    if (el.id === id) {
      obj = el;
    }
    if (el.childrenList && el.childrenList.length > 0 && !obj) {
      obj = getCategoryObj(el.childrenList, id);
    }
  });
  return obj || {};
};

if (route.query.courseType) {
  map.courseType = Number(route.query.courseType);
}
if (route.query.orderByType) {
  map.orderByType = Number(route.query.orderByType);
}
if (route.query.categoryId) {
  map.categoryId = route.query.categoryId;
}
if (route.query.chargeType) {
  map.chargeType = Number(route.query.chargeType);
}

const handleHoverFirstCategory = (item) => {
  if (!item?.id) return;
  const sameActive = String(opts.activeFirstCategoryId) === String(item.id);
  opts.activeFirstCategoryId = item.id;
  syncDefaultSecondHover(item);

  const nextPreviewId = resolveFirstCategoryPreviewId(item);
  if (String(browsePreviewCategoryId.value) === String(nextPreviewId) && sameActive) {
    return;
  }
  browsePreviewCategoryId.value = nextPreviewId;
  page.pageCurrent = 1;
  getTableList();
};

/** 一级分类点击：无二/三级时进入结果页筛选；有下级时默认选中第一个二级并预览 */
const handleClickFirstCategory = (item) => {
  if (!item?.id) return;
  opts.activeFirstCategoryId = item.id;
  if (!hasCategoryChildren(item)) {
    handleSelectCategory(item);
    return;
  }
  syncDefaultSecondHover(item);
  const nextPreviewId = resolveFirstCategoryPreviewId(item);
  if (String(browsePreviewCategoryId.value) === String(nextPreviewId)) return;
  browsePreviewCategoryId.value = nextPreviewId;
  page.pageCurrent = 1;
  getTableList();
};

const handleSelectCategory = (row) => {
  const categoryId = row?.id || "";
  if (String(map.categoryId) === String(categoryId)) return;
  const query = { ...(route.query || {}) };
  if (categoryId) {
    query.categoryId = categoryId;
  } else {
    delete query.categoryId;
  }
  router.push({ query }).then(() => {
    document.querySelector("#app")?.scrollTo?.(0, 0);
  });
};
const { data, pending, error } = await useAsyncData(
  "courseListPage",
  () => {
    return new Promise(async (resolve) => {
      // 确保 pageCurrent 有正确的初始值
      if (!page.pageCurrent || page.pageCurrent < 1) {
        page.pageCurrent = 1;
      }
      
      // 资源列表的请求
      const courseParam = {
        pageCurrent: page.pageCurrent,
        pageSize: page.pageSize,
        ...map,
      };
      let courseFn = getAuthCourseList;
      if (!token.value) {
        courseFn = getCourseList;
      }

      Promise.allSettled([
        courseFn(courseParam),
        getEnumList("CourseTypeEnum", "arr"),
        getEnumList("ChargeTypeEnum", "arr"),
        getEnumList("OrderByTypeEnum", "arr"),
        categoryLists({}),
      ]).then(
        ([course, CourseTypeEnum, ChargeTypeEnum, OrderByTypeEnum, categoryList]) => {
          const data = {};
          if (course.status === "fulfilled") {
            data.course = course.value;
          } else {
            data.course = {};
          }
          if (CourseTypeEnum.status === "fulfilled") {
            data.CourseTypeEnum = CourseTypeEnum.value;
          } else {
            data.CourseTypeEnum = [];
          }
          if (ChargeTypeEnum.status === "fulfilled") {
            data.ChargeTypeEnum = ChargeTypeEnum.value;
          } else {
            data.ChargeTypeEnum = [];
          }
          if (OrderByTypeEnum.status === "fulfilled") {
            data.OrderByTypeEnum = OrderByTypeEnum.value;
          } else {
            data.OrderByTypeEnum = [];
          }
          if (categoryList.status === "fulfilled") {
            data.categoryList = categoryList.value;
          } else {
            data.categoryList = [];
          }

          resolve(data);
        }
      );
    });
  },
  { initialCache: false }
);
if (!pending.value && data.value) {
  const d = data.value;
  opts.chargeTypeEnum = d.ChargeTypeEnum;
  opts.PeriodTypeEnum = d.CourseTypeEnum;
  opts.orderByTypeEnum = d.OrderByTypeEnum;
  if (d && d.course) {
    ctrl.tableLoading = false;
    opts.tableList = d.course.list || [];
    // 确保 pageCurrent 有值，如果没有则使用默认值 1
    page.pageCurrent = d.course.pageCurrent || 1;
    page.totalCount = d.course.totalCount;
    page.totalPage = d.course.totalPage;
  }

  if (d.categoryList && d.categoryList.length) {
    initCategoryState(d.categoryList);
  }
}
const getNavList = () => {
  getNavTypeList({ resourceNavType: 1 }).then((res) => {
    opts.navTypeList = res;
    console.log('courselist',res);
    if (opts.navTypeList && opts.navTypeList.length > 0) {
      map.courseType = opts.navTypeList[0].navCode
    } else {
      map.courseType = null;
    }
    // map.courseType = opts.navTypeList[0].navCode || null;
    let flag = false;
    res.forEach((el) => {
      if (el.navCode === map.courseType) {
        flag = true;
      }
    });
    if (!flag) {
      if (opts.navTypeList && opts.navTypeList.length > 0) {
        map.courseType = opts.navTypeList[0].navCode
      } else {
        map.courseType = null;
      }
      // map.courseType = opts.navTypeList[0].navCode;
    }
    
    // 确保 pageCurrent 有正确的初始值
    if (!page.pageCurrent || page.pageCurrent < 1) {
      page.pageCurrent = 1;
    }
    
    getTableList();
  });
};
// router.beforeResolve((to) => {
//   if(to.path === '/course/list') {
//     if(to.query.courseType !==  map.courseType || to.query.orderByType !== map.orderByType || to.query.chargeType !== map.chargeType || to.query.categoryId !== map.categoryId) {
//       getData(to.query);
//     }
//   }
// });
watch(
  () => route.fullPath,
  () => {
    if (route.path === "/course/list") {
      if (
        Number(route.query.courseType) !== map.courseType ||
        Number(route.query.orderByType) !== map.orderByType ||
        Number(route.query.chargeType) !== map.chargeType ||
        route.query.categoryId !== map.categoryId
      ) {
        getData(route.query);
      }
    }
  }
);
onMounted(() => {
  href.value = window.location.hostname
  ensureCourseCenterNavName();
  
  // 确保 pageCurrent 有正确的初始值
  if (!page.pageCurrent || page.pageCurrent < 1) {
    page.pageCurrent = 1;
  }
  
  getNavList();
  if (token.value) {
    if (userInfo.value.firstLogin) {
      if (!getSession("routeCourse")) {
        nextTick(() => {
          driverObj.drive();
        });
        setSession("routeCourse", window.location.pathname);
      }
    }
  }
});
const driverObj = driver({
  overlayOpacity: 0.5,
  showProgress: true,
  allowClose: false,
  // showButtons: ['next', 'previous', 'close'],
  showButtons: ["next"],
  // prevBtnText: "上一步",
  nextBtnText: "下一步",
  doneBtnText: "完成",
  steps: [
    {
      element: ".courseStep1",
      popover: {
        title: "step1",
        description: "可查看所有资源",
        side: "left",
        align: "center",
      },
    },
    {
      element: ".courseStep2",
      popover: {
        title: "step2",
        description: "按资源类型查看相应资源",
        side: "left",
        align: "center",
      },
    },
    {
      element: ".courseStep3",
      popover: {
        title: "step3",
        description: "按报考需求查看相应资源",
        side: "left",
        align: "center",
      },
    },
  ],
});
onUnmounted(() => {
  if (opts.infoTimer) {
    clearInterval(opts.infoTimer);
    opts.infoTimer = null;
  }
  driverObj.destroy();
});
</script>

<style scoped lang="scss">
.course_content {
  width: 1200px;
  margin: auto;
  background: #f6f8fb;
  .course_header_content {
    padding: 18px 20px 4px 0;
    margin-bottom: 15px;
    background: #fff;
    border-radius: 5px;
    border-top: 3px solid #ff6b00;
  }
}

.app_container {
  overflow: auto;
}

.ov_course_content {
  margin-top: 20px;
  margin-bottom: 20px;
  //overflow: auto;
}

.page_list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg_box {
  width: 100%;
  background-color: #ffffff;
  //border-radius: 5px;
  //padding: 5px 10px;

  &:first-child {
    margin-top: 20px;
  }

  & + .bg_box {
    //margin-top: 10px;
  }
}

.category_filter_panel {
  display: flex;
  min-height: 320px;
  margin-top: 10px;
}

.category_sidebar {
  flex: 0 0 140px;
  border-right: 1px solid #e8e8e8;
  padding: 8px 0;

  .sidebar_item {
    position: relative;
    padding: 14px 12px 14px 18px;
    /* 与课程卡片标题 .item_text 一致：PingFang SC / #333 / 常规字重 */
    font-family: PingFang SC, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    text-align: center;
    cursor: pointer;
    line-height: 1.4;
    transition: color 0.2s;

    .sidebar_dot {
      display: none;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #ff6b00;
      z-index: 2;
    }

    .sidebar_name {
      display: block;
      word-break: break-all;
    }

    &:hover {
      color: #ff6b00;
    }

    &.active {
      color: #ff6b00;
      font-weight: 400;

      .sidebar_dot {
        display: block;
      }
    }
  }
}

.category_content_panel {
  flex: 1;
  padding: 16px 24px;
  overflow: visible;
}

.category_empty_panel {
  height: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 107, 0, 0.04);
    color: #ff6b00;
  }

  .empty_title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .empty_desc {
    font-size: 13px;
  }
}

.category_row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.15s;
  overflow: visible;

  &:last-child {
    border-bottom: none;
  }

  &.is-hover {
    background: #f5f5f5;

    .row_label {
      color: #ff6b00;
      font-weight: 400;

      /* 圆点落在二级右侧竖实线上（含无三级的叶子项） */
      &::after {
        content: "";
        position: absolute;
        right: -3px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ff6b00;
        z-index: 2;
      }
    }
  }

  .row_label {
    position: relative;
    flex: 0 0 150px;
    width: 150px;
    max-width: 150px;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
    padding: 12px 10px;
    border-right: 1px solid #e8e8e8;
    box-sizing: border-box;
    /* 不设 overflow:hidden，避免裁切右侧圆点 */
    word-break: break-all;
  }

  .row_tags {
    flex: 1;
    min-width: 0;
    /* 与课程卡片标题 .item_text 一致：PingFang SC / #333 / 常规字重 */
    font-family: PingFang SC, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 2.2;
    color: #333;
    padding: 12px 0 12px 16px;
  }

  /* 名称与后置分隔符绑成一体，换行时不会出现行首单独的 | */
  .tag_item {
    display: inline-block;
    white-space: nowrap;
  }

  .tag_divider {
    margin: 0 10px;
    color: #ddd;
    user-select: none;
  }

  .tag_link {
    cursor: pointer;
    font-family: inherit;
    font-weight: 400;
    transition: color 0.2s;

    &:hover,
    &.active {
      color: #ff6b00;
    }

    &.active {
      font-weight: 400;
    }
  }
}

.search_type_list {
  // min-height: 50px;
  display: flex;
  //align-items: center;
  //flex-wrap: wrap;

  & + .search_type_list {
    //margin-top: 14px;
  }

  .search_type_item {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-right: 10px;
    padding: 6px 10px;
    &.not_right {
      margin-right: 0;
    }

    &.active {
      color: #2256f6;
      font-weight: bold;
      background: rgba(34, 86, 246, 0.05);
      border-radius: 5px;
    }
  }
}

.border_hr {
  border: 1px solid #becadb;
  height: 14px;
  margin-left: 30px;
  margin-right: 30px;
}
.course_row {
  display: flex;
  margin-bottom: 14px;
  .left_title {
    color: #1a1a1a;
    height: 30px;
    line-height: 30px;
    min-width: 70px;
    background: #fff;
  }
}
.fliter_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  .left_wrapper {
    background: #fff;
    border-radius: 40px;
    padding: 0 5px;
    .search_item {
      margin: 12px 15px;
      display: inline-block;
      cursor: pointer;
    }
    .active {
      color: #2256f6;
      font-weight: 700;
    }
  }
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #333;
}

.result_breadcrumb_bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 12px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 0;

  .my_course_link {
    font-size: 14px;
    color: #666;
    white-space: nowrap;

    &:hover {
      color: #2256f6;
    }
  }

  :deep(.el-breadcrumb__inner) {
    color: #666;
    font-weight: normal;
  }

  :deep(.el-breadcrumb__inner.is-link:hover) {
    color: #2256f6;
  }
}

.result_filter_header {
  background: linear-gradient(135deg, #1e2d4d 0%, #2a3f6b 100%);
  padding: 20px 24px;
  margin-bottom: 20px;

  .filter_row {
    display: flex;
    align-items: flex-start;
    padding: 10px 0;

    & + .filter_row {
      border-top: 1px solid rgba(255, 255, 255, 0.08);
    }
  }

  .filter_label {
    flex: 0 0 80px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 32px;
    white-space: nowrap;
  }

  .filter_tags {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 6px;
  }

  .filter_tag {
    display: inline-block;
    padding: 6px 14px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    border-radius: 4px;
    line-height: 20px;
    transition: all 0.2s;

    &:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.1);
    }

    &.active {
      color: #fff;
      background: #3d7fff;
      font-weight: 500;
    }
  }
}
</style>
